// Load External Libraries
//import AOS from 'aos'
import 'owl.carousel';
import {jarallax, jarallaxVideo} from 'jarallax';
import {Fancybox} from "@fancyapps/ui";
import 'scrollmagic/scrollmagic/minified/ScrollMagic.min';

// other packages here...

window.$ = window.jQuery = jQuery;

//Load Bootstrap Libraries
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
//import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown'; //also requires Popper
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover'; //also requires Popper
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import Tooltip from 'bootstrap/js/dist/tooltip'; //also requires Popper

//Local imports
import { serviceWorker } from './modules/_serviceWorker.mjs';
import { validate } from './modules/_validate.mjs';
import { exampleSlider } from "./modules/_carousels.mjs";
import {menu} from "./modules/_header.mjs";
import {servicesCarousel} from "./modules/_services.mjs";
import {animate} from "./modules/_animate.mjs";
import {replaceSubmitButtonText} from "./modules/_form.mjs";
import {clientCarousel} from "./modules/_clients.mjs";

//initialize functions
document.addEventListener("DOMContentLoaded", function() {
    serviceWorker();
    validate();
    menu();
    servicesCarousel();
    animate();
    replaceSubmitButtonText();
    clientCarousel();
    //exampleSlider()
    //AOS.init({startEvent: 'load', disable: 'mobile'});
    jarallax(document.querySelectorAll('.jarallax'), { speed: 0.5 });
    //jarallaxVideo();

    $(window).resize(function() {
        clientCarousel();
    })
});